/* eslint-disable react/no-children-prop */
/* eslint-disable @next/next/no-img-element */
import ParkingAtMap from '@/components2/ParkingAtMap';
import SearchImage from '@/components/SearchImage';
import { cacheFetch } from '@/helpers/cacheFetch';
import usePrefix from '@/hooks/usePrefix';
import AuthStore from '@/stores/AuthStore';
import ReservationStore from '@/stores/ReservationStore';
import { fetchTemplate, isServer } from '@/utils/isServer';
import BookingDetails, { displayTotalPrice } from '@/components/BookingDetails';
import { absoluteServerPath, CDN1, CDN2, resolveConfigUrl } from '@helpers/api';
import { useMobxStores } from '@stores/index';
import {
  Affix,
  Breadcrumb,
  Button,
  Modal,
  Popover,
  Rate,
  Skeleton,
} from 'antd';
import dayjs from 'dayjs';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { formatCurrency } from '@/helpers/format';
import Reviews from '@/components2/Reviews';
import { mapReviewStars } from '@/utils/tools';
import { getServerSideProps as hgetServerSideProps } from '@pages/myapp/parkingat/[friendlyUrl]';
import { getParkingAtPath, getUrlCodeOrSlug } from '@/utils/newparkingatroutes';
import FacilityTypeDeal from '@/utils/facilityTypeDeal';
import TitleParkingAt from '@/components/TitleParkingAt';
import Rating from '@/components2/NewParkingAt/Rating';
import WithoutShuttles from '@/components2/FacilityHighlights/ParkingAt/WithoutShuttles';
import WithShuttles from '@/components2/FacilityHighlights/ParkingAt/WithShuttles';
import ParkingAtDateMonthly from '@/components2/NewParkingAt/ParkingAtDateMonthly';
import ParkingAtRangePicker from '@/components2/NewParkingAt/ParkingAtRangePicker';
import ParkingAtSelectDate from '@/components2/NewParkingAt/ParkingAtSelectDate';
import ImageGalleryMobile from '@/components2/NewParkingAt/ImageGalleryMobile';
import ImageGallery from '@/components2/NewParkingAt/ImageGallery';
import ParkingAtScrollBtn from '@/components2/NewParkingAt/ParkingAtScrollBtn';
import ParkingAtModalContentNew from '@/components2/NewParkingAt/ParkingAtModalContentNew';
import ParkingAtModalContentOld from '@/components2/NewParkingAt/ParkingAtModalContentOld';
import { canonicalUrl } from '@/helpers/history';
import { useStorageCheckinCheckout } from '@/hooks/useLocalstorage';
import RangePickerWithTime from '@/components2/RangePickerWithTime';

// This also gets called at build time
export const getServerSideProps: GetServerSideProps = async (ctx) => {
  return await hgetServerSideProps(ctx);
};
function loadDate(date, time) {
  // if (time) {
  //   return dayjs('${date}T${time}');
  // }
  return dayjs(date);
}
// pages/parking/[friendlyUrl].js
function Parking({
  configInfo,
  baseUrlSite,
  facility,
  highlights,
  localNow,
  edit,
  airport,
  reviews,
  reviews2,
  deviceType,
  images_parking_at,
  testScope,
}) {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const prefix = usePrefix();
  const detailInfoRef = useRef(null);
  const detailsRef = useRef(null);
  const highlightsRef = useRef(null);
  const locationRef = useRef(null);
  const reviewsRef = useRef(null);
  const nearbyRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const [showAffix, setShowAffix] = useState(false);
  const DISABLE_SCROLLING_CLASS = 'scroll-disabled';
  function disableScroll() {
    const body = document.querySelector('body');
    body.classList.add(DISABLE_SCROLLING_CLASS);
  }

  function ableScroll() {
    const body = document.querySelector('body');
    body.classList.remove(DISABLE_SCROLLING_CLASS);
  }

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setShowAffix(true);
    } else {
      setShowAffix(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const {
      reservationStore,
      authStore,
    }: { reservationStore: ReservationStore; authStore: AuthStore } =
      useMobxStores(),
    checkedHighlights = highlights.filter((highlight) => highlight.check),
    [checkinCheckout, setCheckinCheckout, setCheckinCheckoutCustom] =
      useStorageCheckinCheckout(facility),
    [isModalConfirmDateTimeVisible, setIsModalConfirmDateTimeVisible] =
      useState(false),
    [isModalChangeDateVisible, setIsModalChangeDateVisible] = useState(false),
    checkInSessionStorage =
      !isServer && sessionStorage.getItem('checkin')
        ? dayjs(sessionStorage.getItem('checkin')).format()
        : loadDate(
            checkinCheckout.checkin,
            checkinCheckout.checkintime
          ).format(),
    checkOutSessionStorage =
      !isServer && sessionStorage.getItem('checkout')
        ? dayjs(sessionStorage.getItem('checkout')).format()
        : loadDate(
            checkinCheckout.checkout,
            checkinCheckout.checkouttime
          ).format(),
    sleepAtSessionStorage =
      !isServer && sessionStorage.getItem('sleepAt')
        ? sessionStorage.getItem('sleepAt')
        : facility.facilityParkingType == 3
        ? '1'
        : null,
    [dateRange, setDaterange] = useState({
      checkIn: checkInSessionStorage
        ? dayjs(checkInSessionStorage).format('MM/DD/YYYY')
        : facility.facilityParkingType == 0
        ? dayjs().add(1, 'day').format()
        : dayjs().format(),
      checkOut: checkOutSessionStorage
        ? dayjs(checkOutSessionStorage).format('MM/DD/YYYY')
        : facility.facilityParkingType == 1
        ? dayjs().add(5, 'day').format()
        : facility.facilityParkingType == 0
        ? dayjs().add(8, 'day').format()
        : dayjs().add(1, 'day').format(),
      sleepAt: sleepAtSessionStorage,
    }),
    facilityTimeRem = dayjs(localNow),
    facilityTimeHere = dayjs().hour(dayjs().hour()).minute(30).second(0),
    facilityTime = facilityTimeRem.isValid()
      ? facilityTimeRem
      : facilityTimeHere,
    hour = facilityTime.hour(),
    min = facilityTime.minute(),
    [changedDateTime, setChangedDateTime] = useState({
      checkIn: false,
      checkOut: false,
      dtCheckin: null,
      dtCheckout: null,
      sleepAt: null,
    });
  const parkingAtPath = getParkingAtPath(facility?.Airport);
  function getHourCheckinCheckout() {
    let currentCheckinDate = dayjs(sessionStorage.getItem('checkin'));
    if (!currentCheckinDate.isValid()) currentCheckinDate = facilityTime;
    let currentCheckoutDate = dayjs(sessionStorage.getItem('checkout'));
    if (!currentCheckoutDate.isValid()) currentCheckoutDate = facilityTime;

    return {
      checkin: {
        hour: currentCheckinDate.hour(),
        minute: currentCheckinDate.minute(),
      },
      checkout: {
        hour: currentCheckoutDate.hour(),
        minute: currentCheckoutDate.minute(),
      },
    };
  }
  async function handleConfirmDateTimeOk() {
    applyModalData();
    const status = await reloadDatesAndPrice();
    setIsModalConfirmDateTimeVisible(false);
    ableScroll();
    setChangedDateTime({ ...changedDateTime, checkIn: false, checkOut: false });
    if (reservationStore.facilityStatus === 'default') {
      if (
        !isServer &&
        !sessionStorage.getItem('checkin') &&
        !sessionStorage.getItem('checkout')
      ) {
        sessionStorage.setItem(
          'checkin',
          dayjs(dateRange.checkIn).hour(dayjs().hour()).minute(30).format()
        );
        sessionStorage.setItem(
          'checkout',
          dayjs(dateRange.checkOut).hour(dayjs().hour()).minute(30).format()
        );
      }
      setCheckinCheckoutCustom(
        dayjs(dateRange.checkIn),
        dayjs(dateRange.checkOut),
        1
      );
      router.push({
        pathname: prefix + '/parkingat/checkout',
        query: {
          facility: facility.facility_url_code.toLowerCase(),
        },
      });
    }
  }
  function applyModalData() {
    const ndateRange = { ...dateRange };
    if (changedDateTime.checkIn) {
      sessionStorage.setItem('checkin', changedDateTime.dtCheckin.format());
      ndateRange.checkIn = changedDateTime.dtCheckin.format('MM/DD/YYYY');
    }
    if (changedDateTime.checkOut) {
      sessionStorage.setItem('checkout', changedDateTime.dtCheckout.format());
      ndateRange.checkOut = changedDateTime.dtCheckout.format('MM/DD/YYYY');
    }
    const ccheckin = dayjs(sessionStorage.getItem('checkin'));
    const ccheckout = dayjs(sessionStorage.getItem('checkout'));
    if (ccheckin.isSame(ccheckout) || ccheckout.isBefore(ccheckin)) {
      const newCheckout = ccheckin.add(30, 'minutes');
      sessionStorage.setItem('checkout', newCheckout.format());
      ndateRange.checkOut = newCheckout.format('MM/DD/YYYY');
    }
    if (changedDateTime.sleepAt) {
      sessionStorage.setItem('sleepAt', changedDateTime.sleepAt);
      ndateRange.sleepAt = changedDateTime.sleepAt;
    }
    setCheckinCheckoutCustom(
      dayjs(ndateRange.checkIn),
      dayjs(ndateRange.checkOut),
      1
    );
    setDaterange(ndateRange);
  }
  async function handleChangeDateOk() {
    applyModalData();
    // if (checkIfDateHasErrors()) return false;
    await reloadDatesAndPrice();
    setIsModalChangeDateVisible(false);
    ableScroll();
    setChangedDateTime({ ...changedDateTime, checkIn: false, checkOut: false });
  }

  async function reloadDatesAndPrice() {
    const localCheckin =
      !isServer && sessionStorage.getItem('checkin')
        ? sessionStorage.getItem('checkin')
        : dateRange.checkIn;
    const localCheckout =
      !isServer && sessionStorage.getItem('checkout')
        ? sessionStorage.getItem('checkout')
        : dateRange.checkOut;
    await reservationStore.calculatePrice(
      facility,
      authStore.user?.member_id,
      localCheckin,
      localCheckout
    );
    await reservationStore.loadDailyRates(
      facility,
      localCheckin,
      localCheckout
    );
    return reservationStore.loadFacilityStatus(
      reservationStore.bookingPriceDetail?.facilitySearch,
      reservationStore.bookingPriceDetail?.validate_warnings
    );
  }

  function handleConfirmSetDateTimeModal() {
    setIsModalConfirmDateTimeVisible(true);
    disableScroll();
  }

  function handleChangeDatesModal() {
    setIsModalChangeDateVisible(true);
    disableScroll();
  }

  function handleDateOnChange(type, date) {
    if (type === 'checkin') {
      setDaterange({ ...dateRange, checkIn: date });
    } else {
      setDaterange({ ...dateRange, checkOut: date });
    }
  }

  const handleRangeChange = async (dates) => {
    setIsLoading(true);
    if (dates) {
      const [checkIn, checkOut] = dates;
      setDaterange({
        ...dateRange,
        checkIn: dayjs(checkIn).format('MM/DD/YYYY'),
        checkOut: dayjs(checkOut).format('MM/DD/YYYY'),
      });

      sessionStorage.setItem('checkin', dayjs(checkIn).format());
      sessionStorage.setItem('checkout', dayjs(checkOut).format());
      setCheckinCheckoutCustom(dayjs(checkIn), dayjs(checkOut), 1);

      await reloadDatesAndPrice();
    }
    setIsLoading(false);
  };

  const handleCheckingChange = async (date) => {
    setIsLoading(true);
    setDaterange((prevState) => ({
      ...prevState,
      checkIn: dayjs(date).format('MM/DD/YYYY'),
      checkOut:
        facility.facilityParkingType === 4
          ? dayjs(date).add(1, 'month').format('MM/DD/YYYY')
          : prevState.checkOut,
    }));

    sessionStorage.setItem('checkin', dayjs(date).format());
    if (facility.facilityParkingType === 4) {
      const newCheckoutDate = dayjs(date).add(1, 'month').format();
      sessionStorage.setItem('checkout', newCheckoutDate);
    }
    reloadDatesAndPrice();
    setIsLoading(false);
  };

  useEffect(() => {
    let vcheckin = dayjs();
    let vcheckout = dayjs().add(1, 'day');
    let vhourin = hour;
    let vminin = min;
    let vhourout = hour;
    let vminout = min;
    if (checkinCheckout.checkintime) {
      const ss = checkinCheckout.checkintime.split(':');
      vhourin = parseInt(ss[0]);
      vminin = parseInt(ss[1]);
    }
    if (checkinCheckout.checkouttime) {
      const ss2 = checkinCheckout.checkouttime.split(':');
      vhourout = parseInt(ss2[0]);
      vminout = parseInt(ss2[1]);
    }
    if (checkinCheckout.checkin && checkinCheckout.checkout) {
      vcheckin = dayjs(checkinCheckout.checkin);
      vcheckout = dayjs(checkinCheckout.checkout);

      if (
        facility.facilityParkingType == 4 &&
        !vcheckin.add(1, 'month').isSame(vcheckout)
      ) {
        setCheckinCheckoutCustom(vcheckin, vcheckin.add(1, 'month'), 1);
        return;
      }

      try {
        const v = dayjs(sessionStorage.getItem('checkin'));
        if (v.isValid()) {
          vhourin = v.hour();
          vminin = v.minute();
        }
      } catch (e) {
        console.log(e);
      }
      try {
        const v = dayjs(sessionStorage.getItem('checkout'));
        if (v.isValid()) {
          vhourout = v.hour();
          vminout = v.minute();
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (!sessionStorage.getItem('checkin')) {
      sessionStorage.setItem(
        'checkin',
        vcheckin.hour(vhourin).minute(vminin).second(0).format()
      );
    }
    if (!sessionStorage.getItem('checkout')) {
      sessionStorage.setItem(
        'checkout',
        vcheckout.hour(vhourout).minute(vminout).second(0).format()
      );
    }

    if (!sessionStorage.getItem('sleepAt')) {
      sessionStorage.setItem('sleepAt', sleepAtSessionStorage);
    }

    if (edit === 'true') setIsModalConfirmDateTimeVisible(true);
    reloadDatesAndPrice();
  }, [edit, facility.facility_url_code, hour, min, router, checkinCheckout]);

  useEffect(() => {
    const loadRev = async () => {
      await reservationStore.loadReviewsBySortStar(facility);
    };
    loadRev();
  }, [reservationStore, facility]);

  const bestReview = reviews2?.review_grade ?? facility?.facility_review ?? 5;

  if (!isServer && airport) {
    router.push(`${prefix}/parking/${airport.airport_frienldy_url}`);
    return <></>;
  }

  const textTotalPrice = formatCurrency({
    value: displayTotalPrice(reservationStore, true),
    locale: 'EN-US',
    currency: 'USD',
  });

  const showHighlights =
    facility.Airport?.airport_display_type != 1 &&
    !!facility.Airport?.airport_frienldy_url;

  return (
    <div id="parkingat" ref={setContainer}>
      <TitleParkingAt
        info={{
          ...facility,
          ...facility.Airport,
        }}
      />
      <Head>
        <meta
          name="description"
          content={`Find the best parking deals at ${facility.facility_airport_name}.`}
          key="description"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Product',
              name: facility.facility_lot,
              url: `https://www.onairparking.com/${parkingAtPath}/${getUrlCodeOrSlug(
                facility
              )}`,
              image:
                'https://www.onairparking.com/assets/public/image/logo_web.png',
              aggregateRating: {
                '@type': 'AggregateRating',
                bestRating: Math.ceil(bestReview).toString(),
                ratingCount: reviews2?.nreview?.toString(),
                ratingValue: reviews2?.review_grade?.toString(),
              },
            }),
          }}
        />
        <link rel="canonical" href={canonicalUrl(baseUrlSite, router)} />
        <link
          rel="preload"
          href={CDN2() + '/staticmyapp/default-image.png'}
          as="image"
        />
      </Head>

      <div className="mx-auto max-w-[81.25rem] md:px-4 md:pt-12">
        <article className="md:space-y-6">
          <div className="flex md:hidden">
            {facility.facilityParkingType == 4 ? (
              <ParkingAtDateMonthly
                setChangedDateTime={setChangedDateTime}
                dateRange={dateRange}
                hchangeCheckin={handleCheckingChange}
                changedDateTime={changedDateTime}
                deviceType="mobile"
                facility={facility}
              />
            ) : (
              <div className="flex w-full mt-4 md:mt-0 px-4 md:px-0">
                <RangePickerWithTime
                  isCity={facility.facilityParkingType == 2}
                  checkin={
                    !isServer && sessionStorage.getItem('checkin')
                      ? sessionStorage.getItem('checkin')
                      : checkinCheckout.checkin
                  }
                  checkout={
                    !isServer && sessionStorage.getItem('checkout')
                      ? sessionStorage.getItem('checkout')
                      : checkinCheckout.checkout
                  }
                  onChange={handleRangeChange}
                  deviceType={deviceType}
                  isParkingAt
                />
              </div>
            )}
          </div>
          <Breadcrumb className="text-sm md:text-base mt-4 md:mt-0 px-4 hidden md:flex">
            <Breadcrumb.Item>
              <a href="/">Home</a>
            </Breadcrumb.Item>
            {facility.Airport?.airport_display_type != 1 &&
              !!facility.Airport?.airport_frienldy_url && (
                <Breadcrumb.Item>
                  <a
                    href={`/parking/${facility.Airport?.airport_frienldy_url}`}
                  >
                    {facility.Airport?.airport_name}
                  </a>
                </Breadcrumb.Item>
              )}
            <Breadcrumb.Item>{facility.facility_lot}</Breadcrumb.Item>
          </Breadcrumb>
          <div
            className={`md:hidden flex justify-center items-center mx-auto ${
              images_parking_at.length > 0 ? 'h-96' : ' h-80'
            } w-full overflow-hidden`}
          >
            {facility.facility_branded == 1 ? (
              <>
                {images_parking_at.length > 0 ? (
                  <ImageGalleryMobile images_parkingAt={images_parking_at} />
                ) : (
                  <SearchImage
                    src={CDN2() + '/staticmyapp/cards-default-image.webp'}
                    errorImage={
                      CDN2() + '/staticmyapp/cards-default-image.webp'
                    }
                    quality={100}
                    placeholder="blur"
                    className="z-0 object-cover w-full h-80 object-center bg-origin-border"
                    fill
                    alt={`Airport: ${facility.facility_lot} Background`}
                    native
                  />
                )}
              </>
            ) : (
              <SearchImage
                src={CDN2() + '/staticmyapp/cards-default-image.webp'}
                errorImage={CDN2() + '/staticmyapp/cards-default-image.webp'}
                quality={100}
                placeholder="blur"
                className="z-0 object-cover w-full h-80 object-center bg-origin-border"
                fill
                alt={`Airport: ${facility.facility_lot} Background`}
                native
              />
            )}
          </div>
          <div className="hidden md:flex justify-center items-center mx-auto h-96 w-full overflow-hidden">
            {facility.facility_branded == 1 ? (
              <>
                {images_parking_at.length > 0 ? (
                  <ImageGallery
                    images_parkingAt={images_parking_at}
                    facilityLot={facility.facility_lot}
                  />
                ) : (
                  <SearchImage
                    src={CDN2() + '/staticmyapp/cards-default-image.webp'}
                    errorImage={
                      CDN2() + '/staticmyapp/cards-default-image.webp'
                    }
                    quality={100}
                    placeholder="blur"
                    className="z-0 object-cover w-full h-96 object-center bg-origin-border"
                    fill
                    alt={`Airport: ${facility.facility_lot} Background`}
                    native
                  />
                )}
              </>
            ) : (
              <SearchImage
                src={CDN2() + '/staticmyapp/cards-default-image.webp'}
                errorImage={CDN2() + '/staticmyapp/cards-default-image.webp'}
                quality={100}
                placeholder="blur"
                className="z-0 object-cover w-full h-96 object-center bg-origin-border"
                fill
                alt={`Airport: ${facility.facility_lot} Background`}
                native
              />
            )}
          </div>

          <div className="flex md:hidden mt-2">
            <ParkingAtScrollBtn
              detailsRef={detailsRef}
              highlightsRef={highlightsRef}
              locationRef={locationRef}
              reviewsRef={reviewsRef}
              showHighlights={showHighlights}
            />
          </div>
          <section
            className={`max-w-[88.75rem] mx-auto relative gap-x-10 flex flex-col md:flex-row px-4 md:px-0`}
          >
            <div className={`col-span-2 md:w-4/6 ml-auto`}>
              <h1 className="text-xl md:text-[2.125rem] font-medium my-4 md:mt-0">
                {facility.facility_lot}
              </h1>
              {facility.facility_is_express_deal > 0 && (
                <p className="rounded-md h-5 w-40 text-center font-semibold text-sm italic text-white bg-secondary mb-1.5 md:hidden">
                  {FacilityTypeDeal(facility)}
                </p>
              )}
              <Rating
                review_grade={reviews2?.review_grade}
                facilityAddress={facility.facility_address}
                facilityDistance={facility.facility_airport_distance}
                facilityCode={facility?.Airport?.airport_initials}
                isBranded={facility.facility_branded}
                locationRef={locationRef}
                reviewsRef={reviewsRef}
                highlights={highlights}
                unbrandedAddress={configInfo.unbrandedAddress}
              />

              <WithShuttles
                facility={facility}
                highlights={highlights}
                size="small"
              />

              <aside
                className={`bg-gray-100 md:hidden w-full z-20 fixed bottom-0 left-0 p-1.5 border-2 border-black/50`}
              >
                <ParkingAtSelectDate
                  deviceType={deviceType}
                  dateRange={dateRange}
                  changedDateTime={changedDateTime}
                  setChangedDateTime={setChangedDateTime}
                  facility={facility}
                  textTotalPrice={textTotalPrice}
                  handleChangeDatesModal={handleChangeDatesModal}
                  handleConfirmSetDateTimeModal={handleConfirmSetDateTimeModal}
                  checkInSessionStorage={checkInSessionStorage}
                  onDateChange={() => {
                    setIsModalChangeDateVisible(true);
                    disableScroll();
                  }}
                  groupedDates={toJS(reservationStore.groupedDates)}
                  checkin={
                    !isServer && sessionStorage.getItem('checkin')
                      ? sessionStorage.getItem('checkin')
                      : checkinCheckout.checkin
                  }
                  checkout={
                    !isServer && sessionStorage.getItem('checkout')
                      ? sessionStorage.getItem('checkout')
                      : checkinCheckout.checkout
                  }
                  handleRangeChange={handleRangeChange}
                  handleCheckingChange={handleCheckingChange}
                  isLoading={isLoading}
                />
              </aside>
              <div className="hidden md:flex border-b">
                <ParkingAtScrollBtn
                  detailsRef={detailsRef}
                  highlightsRef={highlightsRef}
                  locationRef={locationRef}
                  reviewsRef={reviewsRef}
                  showHighlights={showHighlights}
                />
              </div>
              <h3
                className="text-[1.625rem] font-bold mt-4 md:mt-8 mb-[1.938rem]"
                ref={detailsRef}
              >
                Details
              </h3>
              <p className="text-[1.063rem] leading-8 mb-7">
                {facility.facility_description}
              </p>
              <div className="border-b"></div>
              {facility.Airport?.airport_display_type != 1 &&
                !!facility.Airport?.airport_frienldy_url && (
                  <>
                    <h3
                      className="text-[1.625rem] font-bold mt-4 md:mt-8 mb-[1.938rem]"
                      ref={highlightsRef}
                    >
                      Highlights
                    </h3>
                    <WithoutShuttles
                      facility={facility}
                      highlights={highlights}
                      size="small"
                    />
                    <div className="border-b mt-8"></div>
                  </>
                )}
              <h3
                className="text-[1.625rem] font-bold mt-4 md:mt-8 mb-[1.938rem]"
                ref={locationRef}
              >
                Location
              </h3>
              {facility.facility_branded == 1 && (
                <>
                  <h3 className="text-xl font-semibold mt-4 md:mt-8 mb-4">
                    Address
                  </h3>
                  <h1 className="md:text-base mb-[2.438rem]">
                    {facility.facility_address}
                    <a
                      target="_blank"
                      href={`http://maps.google.com/maps?daddr=${facility.facility_latitude_fake},${facility.facility_longitude_fake}`}
                      className="text-primary md:text-base ml-4 mr-1"
                    >
                      Get Direction
                    </a>
                  </h1>
                </>
              )}
              <div className="h-auto md:h-80 mb-12 md:mb-20">
                <h3 className="text-xl font-semibold mb-2">Map</h3>
                <ParkingAtMap facility={facility} />
              </div>
              <div className="border-b"></div>

              {!reviews2?.empty && (
                <div className="space-y-8">
                  <h3
                    className="text-[1.625rem] font-bold mt-4 md:mt-8 mb-2"
                    ref={reviewsRef}
                  >
                    Reviews of this Lot
                  </h3>
                  <div className="flex flex-col">
                    <span className={`text-3xl`}>
                      {reviews2?.review_grade >= 4.5
                        ? 'Excellent'
                        : reviews2?.review_grade >= 4.0
                        ? 'Very Good'
                        : 'Good'}
                    </span>
                    <span className={`text-2xl font-bold`}>
                      {mapReviewStars(reviews2?.review_grade)} / 5
                    </span>
                    <Rate disabled value={reviews2?.review_grade} allowHalf />

                    <span className="text-sm">
                      (Based on {reservationStore.reviewsTotal}{' '}
                      {reservationStore.reviewsTotal > 1 ? 'reviews' : 'review'}
                      )
                    </span>
                  </div>
                  <Reviews facility={facility} reviews={reviews} />
                </div>
              )}
            </div>

            <aside className={`hidden md:inline mt-10`}>
              <Affix offsetTop={10}>
                <ParkingAtSelectDate
                  deviceType={deviceType}
                  changedDateTime={changedDateTime}
                  setChangedDateTime={setChangedDateTime}
                  dateRange={dateRange}
                  facility={facility}
                  textTotalPrice={textTotalPrice}
                  handleChangeDatesModal={handleChangeDatesModal}
                  handleConfirmSetDateTimeModal={handleConfirmSetDateTimeModal}
                  checkInSessionStorage={checkInSessionStorage}
                  onDateChange={() => {
                    setIsModalChangeDateVisible(true);
                    disableScroll();
                  }}
                  groupedDates={toJS(reservationStore.groupedDates)}
                  checkin={
                    !isServer && sessionStorage.getItem('checkin')
                      ? sessionStorage.getItem('checkin')
                      : checkinCheckout.checkin
                  }
                  checkout={
                    !isServer && sessionStorage.getItem('checkout')
                      ? sessionStorage.getItem('checkout')
                      : checkinCheckout.checkout
                  }
                  handleRangeChange={handleRangeChange}
                  handleCheckingChange={handleCheckingChange}
                  isLoading={isLoading}
                />
              </Affix>
            </aside>
          </section>
        </article>
      </div>
      {/* Confirm Parking Reservation Time */}
      <Modal
        title="Confirm Parking Reservation"
        centered
        visible={isModalConfirmDateTimeVisible}
        destroyOnClose
        onCancel={() => {
          setIsModalConfirmDateTimeVisible(false);
          ableScroll();
        }}
        footer={[
          <Button
            key="submit"
            onClick={handleConfirmDateTimeOk}
            size="large"
            className="uppercase bg-secondary hover:bg-secondary hover:text-white hover:opacity-70 border-0 text-white rounded-full w-full"
          >
            Checkout
          </Button>,
          <small key="msg" className="mt-4 table mx-auto text-sm">
            * Price and inventory subject to availability
          </small>,
        ]}
      >
        <ParkingAtModalContentNew
          setChangedDateTime={setChangedDateTime}
          dateRange={dateRange}
          changeEvent={isModalConfirmDateTimeVisible}
          changedDateTime={changedDateTime}
          hourminRangeFn={getHourCheckinCheckout}
          showTimeDate
          facility={facility}
        />
      </Modal>
      {/* Apply Change Date Time */}
      <Modal
        title="Change Parking Reservation"
        centered
        visible={isModalChangeDateVisible}
        destroyOnClose
        onCancel={() => {
          setIsModalChangeDateVisible(false);
          ableScroll();
        }}
        footer={[
          <Button
            key="submit"
            onClick={handleChangeDateOk}
            size="large"
            className="uppercase bg-secondary hover:bg-secondary hover:text-white hover:opacity-70 border-0 text-white rounded-full w-full"
          >
            Apply
          </Button>,
        ]}
      >
        <ParkingAtModalContentOld
          setChangedDateTime={setChangedDateTime}
          dateRange={dateRange}
          changeEvent={isModalChangeDateVisible}
          hourminRangeFn={getHourCheckinCheckout}
          changedDateTime={changedDateTime}
          showTimeDate
          facility={facility}
          deviceType={deviceType}
        />
      </Modal>
    </div>
  );
}

export default observer(Parking);
